import { render, staticRenderFns } from "./UserAdditionalInfoBox.vue?vue&type=template&id=30ca3cc5&scoped=true"
import script from "./UserAdditionalInfoBox.vue?vue&type=script&lang=js"
export * from "./UserAdditionalInfoBox.vue?vue&type=script&lang=js"
import style0 from "./UserAdditionalInfoBox.vue?vue&type=style&index=0&id=30ca3cc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca3cc5",
  null
  
)

export default component.exports